import api from 'api/apiInstance';

export function clientClientIdentificationsIdentificationDocumentApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
